import { ACTION_NAMES, Texture } from '../../../Constants';
import {
    angryDocks,
    doIHaveTheMaximumStaffAvailableToMe,
    totalStaffCount,
    whichStackHasGhostActions,
    whichStackHasStaffActions, whichStacksHaveThisAction
} from '../../Game/GamePlayerInfo';
import {
    available_docks_for_guest,
    CARD_FACTIONS,
    get_points_for_card
} from '../../TwoD/Common/CardUtilities';
import {
    activateARandomActionRoom,
    canIActivateARandomActionRoom,
    canIActivateThisRoom,
    matchingActionRooms
} from '../../TwoD/Common/StationUtilities';
import { currentActionGrid } from '../../TwoD/Common/ActionHexUtilities';


function _activateActionRoom(gamePlayerController, aiPackage, action) {
    let stack = null;
    if (!gamePlayerController.gamePlayerData.locked_action_stacks[0]) {
        if (gamePlayerController.gamePlayerData.available_actions[0].includes(action)) {
            stack = 0;
        }
    }

    if (!gamePlayerController.gamePlayerData.locked_action_stacks[1]) {
        if (gamePlayerController.gamePlayerData.available_actions[1].includes(action)) {
            stack = 1;
        }
    }
    aiPackage.addProvenance(
        `Are the stacks locked?`,
        stack != null,
        `If a stack isn't locked activate the matching action room.`);

    if (stack != null) {
        const roomsForStack0 = matchingActionRooms(gamePlayerController.gamePlayerData, action);
        const activatedRooms = roomsForStack0.filter(roomData => roomData.activated);
        const deActivatedRooms = roomsForStack0.filter(roomData => !roomData.activated);
        aiPackage.addProvenance(
            `Is there a Matching Action Room?`,
            roomsForStack0.length > 0,
            'Get more actions for the primary action.');
        if (roomsForStack0.length > 0) {
            aiPackage.addProvenance(
                `Is the first ${ACTION_NAMES[action]} Room Activated?`,
                activatedRooms.length !== 0,
                'Get more actions for the primary action.');
            if (activatedRooms.length === 0) {
                const room = deActivatedRooms.pop();
                const canI = canIActivateThisRoom(gamePlayerController.gamePlayerData,
                    room.stationIndex);
                aiPackage.addProvenance(
                    `Can I activate ${room.name}?`,
                    canI,
                    'Activate room for more actions.');
                if (canI) {
                    aiPackage.addToMessage(`Activate ${room.name}`);
                    if (aiPackage.execute) {
                        gamePlayerController.gamePlayerApi.toggleActivation(room.stationIndex);
                    }
                    return true;
                }
            }
        }
    }
    return false;
}


export default function artificialSelectAction(gamePlayerController, aiPackage) {
    // if (_activatePrimaryRoom(gamePlayerController, aiPackage)) return;

    let actionGrid = currentActionGrid(gamePlayerController.gamePlayerData);
    // Is there a staff action? if i am full of staff, take the other action first.
    // if I am ghosted, take the ghost action first.

    let doStaffFirst = false;
    let hasStaff = whichStackHasStaffActions(gamePlayerController.gamePlayerData);
    if (hasStaff != null) {
        doStaffFirst = !doIHaveTheMaximumStaffAvailableToMe(gamePlayerController.gamePlayerData);
    }
    let hasGhostAction = whichStackHasGhostActions(gamePlayerController.gamePlayerData) != null;

    if (actionGrid.length > 0) {
        let question = 'What is the first action available to me?';
        let reason = 'First is easiest.';

        let actionRoomTexture, actionGridIndex;
        if (doStaffFirst) {
            question = 'Staff First.';
            reason = 'I am not full of staff, so I want them to be available.'
            actionRoomTexture = Texture.ROBOT_ACTION;
        } else if (hasGhostAction && angryDocks(gamePlayerController.gamePlayerData).length > 1) {
            question = 'Ghost First.';
            reason = 'Always deal with Angry ghosts before anything else.'
            actionRoomTexture = Texture.GHOST_ACTION;
        } else {
            actionRoomTexture = actionGrid[0];
        }
        let roomName = Texture.NAMES[actionRoomTexture];
        actionGridIndex = actionGrid.indexOf(actionRoomTexture);
        let action = Texture.ACTIONS.indexOf(actionRoomTexture);

        if (_activateActionRoom(gamePlayerController, aiPackage, action)) return;
        aiPackage.addToMessage(`Select ${roomName}`);
        aiPackage.addProvenance(question, roomName, reason);

        if (aiPackage.execute) {
            const actionId = Texture.ACTIONS.indexOf(actionRoomTexture);
            const stackData = whichStacksHaveThisAction(
                gamePlayerController.gamePlayerData,
                actionId)
            let stack = null;
            if (actionId < 7) {
                stack = 0;
                if (!stackData.stacks[0]) stack = 1;
            }
            gamePlayerController.gamePlayerApi.selectActionStack(
                actionGridIndex, actionRoomTexture, stack);
        }

        aiPackage.success = true;

    }

    if (!aiPackage.success) {
        const question = 'Can I activate a Random Action Room?';
        const answer = canIActivateARandomActionRoom(gamePlayerController.gamePlayerData);
        const reason = 'Take every action possible.';
        if (!aiPackage.success && answer) {
            aiPackage.addToMessage(`Activate Random Action Room`);
            aiPackage.addProvenance(question, true, reason);
            if (aiPackage.execute) {
                activateARandomActionRoom(gamePlayerController);
            }
            aiPackage.success = true;
        }
    }


    if (!aiPackage.success) {
        aiPackage.addToMessage(`The turn is over`);
        aiPackage.addProvenance(
            'Is there anything else to do?',
            false,
            'I always hope for more.');
        if (aiPackage.execute) {
            console.log('AI NO MORE ACTIONS, CLICKING DONE.')
            gamePlayerController.gamePlayerApi.clickNext();
        }
    }

    aiPackage.success = true;
}
